import { BaseService } from '~/modules/app'

export class RegisterService extends BaseService {
  add(key: string) {
    if (this.gaApp.stores.modal.register.modals.includes(key)) {
      return
    }

    this.gaApp.stores.modal.register.modals.push(key)

    this.onModalsUpdate()
  }

  remove(key: string) {
    const index = this.gaApp.stores.modal.register.modals.indexOf(key)

    if (index !== -1) {
      this.gaApp.stores.modal.register.modals.splice(index, 1)
      this.gaApp.eventBus.publish('module/modal/register/remove', key)
    }

    this.onModalsUpdate()
  }

  onModalsUpdate() {
    const hasModals = Boolean(this.gaApp.stores.modal.register.hasModals)

    this.gaApp.services.app.pageScroll.update(hasModals)
  }
}
